// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/diagnosis-select/option/option.less
// module id = 3483
// module chunks = 0